import FadeIn from "../ui/FadeIn";
import { VALUES } from "../../data/constants";
import styles from "./About.module.css";

export default function About() {
  return (
    <section id="about" className={styles.section}>
      <div className="section-wrap">
        <div className={styles.grid}>
          <FadeIn>
            <div className={styles.imgWrap}>
              <div className={styles.imgTag}>Est. in Nairobi</div>
              <img
                className={styles.imgMain}
                src="https://images.unsplash.com/photo-1488085061387-422e29b40080?w=800&q=80"
                alt="Global travel planning"
              />
              <img
                className={styles.imgAccent}
                src="https://images.unsplash.com/photo-1530521954074-e64f6810b32d?w=400&q=80"
                alt="Passport and travel documents"
              />
            </div>
          </FadeIn>

          <FadeIn delay={0.15}>
            <div className="sec-label">About Us</div>
            <h2 className="sec-title">
              A Trusted Name<br />in Global Mobility
            </h2>
            <p className={styles.body}>
              Royal Horizon Mobility Ltd is a professionally established travel,
              tourism, and global mobility services company committed to
              delivering reliable, efficient, and high-quality international
              solutions — serving individuals, families, and organizations
              seeking trusted pathways to global destinations.
            </p>

            <div className={styles.valuesGrid}>
              {VALUES.map((v) => (
                <div key={v.title} className={styles.valCard}>
                  <div className={styles.valTitle}>{v.title}</div>
                  <div className={styles.valDesc}>{v.desc}</div>
                </div>
              ))}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
